export default defineNuxtRouteMiddleware(async (to) => {
    if (Object.keys(to.query).length === 0 && to.path !== '/' && !to.path.endsWith('/') && !to.path.includes('.')) {
        return navigateTo(`${to.path}/`, {redirectCode: 301});
    }
});